import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import Header from "@/components/layout/Header";
import Footer from "@/components/layout/Footer";
import { MarketTicker } from "@/components/MarketTicker";
import { Toaster } from "@/components/ui/sonner";
import HomePage from "@/pages/HomePage";
import ArticlePage from "@/pages/ArticlePage";
import CategoryPage from "@/pages/CategoryPage";
import TagPage from "@/pages/TagPage";
import PodcastsPage from "@/pages/PodcastsPage";
import PodcastDetailPage from "@/pages/PodcastDetailPage";
import SearchPage from "@/pages/SearchPage";
import ShortRedirectPage from "@/pages/ShortRedirectPage";
import LoginPage from "@/pages/LoginPage";
import AdminLayout from "@/pages/admin/AdminLayout";
import AdminDashboard from "@/pages/admin/AdminDashboard";
import AdminArticles from "@/pages/admin/AdminArticles";
import AdminArticleEditor from "@/pages/admin/AdminArticleEditor";
import AdminCategories from "@/pages/admin/AdminCategories";
import AdminTags from "@/pages/admin/AdminTags";
import AdminMedia from "@/pages/admin/AdminMedia";
import AdminPodcasts from "@/pages/admin/AdminPodcasts";
import AdminComments from "@/pages/admin/AdminComments";
import AdminHomepage from "@/pages/admin/AdminHomepage";
import AdminDimovskySync from "@/pages/admin/AdminDimovskySync";
import AdminContacts from "@/pages/admin/AdminContacts";
import AdminNewsletterPreview from "@/pages/admin/AdminNewsletterPreview";
import "@/App.css";

function SiteLayout({ children }) {
  return (
    <div className="min-h-screen flex flex-col bg-[#F8F7F3]">
      <Header />
      <MarketTicker />
      <main className="flex-1">{children}</main>
      <Footer />
    </div>
  );
}

function AdminGuard({ children }) {
  const { user } = useAuth();
  if (user === null) return <div className="p-16 text-center text-[#66717B]">Зареждане...</div>;
  if (!user || !["admin", "editor"].includes(user.role)) return <Navigate to="/login" replace />;
  return children;
}

function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <Toaster richColors position="top-center" />
        <Routes>
          <Route path="/" element={<SiteLayout><HomePage /></SiteLayout>} />
          <Route path="/article/:slug" element={<SiteLayout><ArticlePage /></SiteLayout>} />
          <Route path="/category/:slug" element={<SiteLayout><CategoryPage /></SiteLayout>} />
          <Route path="/tag/:slug" element={<SiteLayout><TagPage /></SiteLayout>} />
          <Route path="/podcasts" element={<SiteLayout><PodcastsPage /></SiteLayout>} />
          <Route path="/podcasts/:slug" element={<SiteLayout><PodcastDetailPage /></SiteLayout>} />
          <Route path="/search" element={<SiteLayout><SearchPage /></SiteLayout>} />
          <Route path="/s/:code" element={<ShortRedirectPage />} />
          <Route path="/login" element={<SiteLayout><LoginPage /></SiteLayout>} />
          <Route path="/admin" element={<AdminGuard><AdminLayout /></AdminGuard>}>
            <Route index element={<AdminDashboard />} />
            <Route path="articles" element={<AdminArticles />} />
            <Route path="articles/new" element={<AdminArticleEditor />} />
            <Route path="articles/:id/edit" element={<AdminArticleEditor />} />
            <Route path="categories" element={<AdminCategories />} />
            <Route path="tags" element={<AdminTags />} />
            <Route path="media" element={<AdminMedia />} />
            <Route path="podcasts" element={<AdminPodcasts />} />
            <Route path="comments" element={<AdminComments />} />
            <Route path="homepage" element={<AdminHomepage />} />
            <Route path="dimovsky-sync" element={<AdminDimovskySync />} />
            <Route path="newsletter" element={<AdminNewsletterPreview />} />
            <Route path="contacts" element={<AdminContacts />} />
          </Route>
          <Route path="*" element={<SiteLayout><div className="p-24 text-center font-serif text-2xl text-[#10243A]">Страницата не е намерена</div></SiteLayout>} />
        </Routes>
      </AuthProvider>
    </BrowserRouter>
  );
}

export default App;
